var AppDispatcher = require('../dispatchers/AppDispatcher');
var Constants = require('../constants/Constants');
var Invocation = require('../api/Invocation');
var PaymentConstants = require('../constants/Payment');
var TokenConstants = require('../constants/Token');
var UserStore = require('../stores/UserStore');

var BillingActions = {
    doPayment: function () {
        AppDispatcher.handleViewAction({
            actionType: PaymentConstants.PAY
        });
    },

    newPayment: function () {
        AppDispatcher.handleViewAction({
            actionType: PaymentConstants.NEW
        });
    },

    selectInvoice: function (invoice, selected) {
        AppDispatcher.handleViewAction({
            actionType: PaymentConstants.SELECT_INVOICE,
            invoice: invoice,
            selected: selected
        });
    },

    selectToken: function (token) {
        AppDispatcher.handleViewAction({
            actionType: PaymentConstants.SELECT_TOKEN,
            token: token
        });
    },

    updateCard: function (card) {
        AppDispatcher.handleViewAction({
            actionType: PaymentConstants.UPDATE_CARD,
            card: card
        });
    },

    /**
     * Updates the token for a billing group.
     */
    updateToken: function (billingGroup, token) {
        AppDispatcher.handleViewAction({
            actionType: TokenConstants.UPDATE_GROUP,
            billingGroup: billingGroup,
            token: token
        });
    }
};
module.exports = BillingActions;



// WEBPACK FOOTER //
// ./app/actions/BillingActions.js